// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation-root-PdKOW","ul":"Navigation-ul-3uQCI"};